import { useEffect, useState } from 'react';

function useVariantsAvailabilityStatus(props) {
  const { activeIdx, item_option_variants, variants } = props;
  const [itemOptionVariantLengths, setItemOptionVariantLengths] = useState([]);
  const [outOfStockInfo, setOutOfStockInfo] = useState();
  const [variantNameIndexMap, setVariantNameIndexMap] = useState({});
  const [activeVariantOptions, setActiveVariantOptions] = useState([]);

  useEffect(() => {
    const tempItemOptionVariantLengths = [];
    const tempOptionVariantNameIndexMap = {};
    item_option_variants.forEach((item) => {
      tempItemOptionVariantLengths.push(item[Object.keys(item)[0]].length);
      const tempVariantNameIndexMap = {};
      item[Object.keys(item)[0]].forEach((optionsDetails, index) => {
        tempVariantNameIndexMap[optionsDetails?.variant_name] = index;
      });
      tempOptionVariantNameIndexMap[Object.keys(item)[0]] = tempVariantNameIndexMap;
    });
    setItemOptionVariantLengths(tempItemOptionVariantLengths);
    setVariantNameIndexMap(tempOptionVariantNameIndexMap);
  }, []);

  useEffect(() => {
    variants.forEach((item) => {
      const { optionNameVariantNameMap, isAvaialble } =
        getItemOptionMapAndAvaialableStatus(item);
      !!outOfStockInfo?.length &&
        setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble);
    });
  }, [itemOptionVariantLengths, outOfStockInfo?.length]);

  useEffect(() => {
    const tempActiveVariantOptions = [];
    variants[activeIdx]?.option_variant_names.forEach((item) => {
      tempActiveVariantOptions.push(item?.variant_name);
    });
    setActiveVariantOptions(tempActiveVariantOptions);
  }, [itemOptionVariantLengths]);

  useEffect(() => {
    setOutOfStockInfo(getInitialOutOfStockArray(0));
  }, [itemOptionVariantLengths]);

  function getVariantAvailableStatus(variantData) {
    return variantData?.available;
  }

  function getItemOptionMapAndAvaialableStatus(item) {
    const optionNameVariantNameMap = {};
    const isAvaialble = getVariantAvailableStatus(item);
    !!item.option_variant_names?.length &&
      item.option_variant_names.forEach((optionDetails) => {
        optionNameVariantNameMap[optionDetails?.option_name] =
          optionDetails?.variant_name;
      });
    return { optionNameVariantNameMap, isAvaialble };
  }

  function setVariantAvaialableStatus(optionNameVariantNameMap, isAvaialble) {
    const tempOutOfVisble = outOfStockInfo.slice(0, outOfStockInfo?.length);

    switch (itemOptionVariantLengths?.length) {
      case 1:
        tempOutOfVisble[
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]
          ]
        ] = isAvaialble;
        break;
      case 2:
        tempOutOfVisble[
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]
          ]
        ][
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]
          ]
        ] = isAvaialble;
        break;
      case 3:
        tempOutOfVisble[
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[0]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[0]]
          ]
        ][
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[1]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[1]]
          ]
        ][
          variantNameIndexMap[Object.keys(optionNameVariantNameMap)[2]][
            optionNameVariantNameMap[Object.keys(optionNameVariantNameMap)[2]]
          ]
        ] = isAvaialble;
        break;
    }
    setOutOfStockInfo(tempOutOfVisble);
  }

  function getIndexOneAvalaibleStatus(variantName) {
    if (itemOptionVariantLengths?.length === 3) {
      const selectedVariants =
        variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][
          activeVariantOptions[0]
        ] !== (undefined || null)
          ? outOfStockInfo[
              variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][
                activeVariantOptions[0]
              ]
            ][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]]
          : [];
      return selectedVariants.find((items) => items === true || items === 1);
    } else if (itemOptionVariantLengths?.length === 2) {
      return outOfStockInfo[
        variantNameIndexMap[Object.keys(variantNameIndexMap)[0]][activeVariantOptions[0]]
      ][variantNameIndexMap[Object.keys(variantNameIndexMap)[1]][variantName]];
    }
  }

  function getOneVariantFilterAvailabilty(variantName) {
    let variantOutOfStockStatus = false;
    for (let i = 0; i < variants?.length; i++) {
      for (let j = 0; j < variants[i].option_variant_names?.length; j++) {
        if (variants[i].option_variant_names[j].variant_name === variantName) {
          variantOutOfStockStatus =
            variantOutOfStockStatus || getVariantAvailableStatus(variants[i]);
        }
      }
    }
    return variantOutOfStockStatus;
  }

  function getTwoVariantFilterAvailabilty(variantName, index) {
    switch (index) {
      case 1:
        return getIndexOneAvalaibleStatus(variantName);
    }
  }

  function getThreeVariantFilterAvailabilty(variantName) {
    return outOfStockInfo
      ? outOfStockInfo[
          variantNameIndexMap[Object.keys(variantNameIndexMap || {})?.[0]]?.[
            activeVariantOptions?.[0]
          ]
        ]?.[
          variantNameIndexMap[Object.keys(variantNameIndexMap || {})?.[1]]?.[
            activeVariantOptions?.[1]
          ]
        ]?.[
          variantNameIndexMap[Object.keys(variantNameIndexMap || {})?.[2]]?.[variantName]
        ]
      : false;
  }

  function returnIsVariantAvailable(variantName, index) {
    switch (index) {
      case 0:
        return getOneVariantFilterAvailabilty(variantName, index);
      case 1:
        return getTwoVariantFilterAvailabilty(variantName, index);
      case 2:
        return getThreeVariantFilterAvailabilty(variantName, index);
    }
  }

  function getInitialOutOfStockArray(ptypeIndex) {
    if (ptypeIndex === itemOptionVariantLengths?.length - 1) {
      return Array(itemOptionVariantLengths[ptypeIndex])
        .fill(0)
        .slice(0, itemOptionVariantLengths[ptypeIndex]);
    } else {
      let rowSize = itemOptionVariantLengths[ptypeIndex];
      const parentArray = [];
      while (rowSize) {
        parentArray.push(getInitialOutOfStockArray(ptypeIndex + 1));
        rowSize--;
      }
      const length = parentArray.length;
      return parentArray.slice(0, length);
    }
  }

  return {
    returnIsVariantAvailable,
    setActiveVariantOptions,
    activeVariantOptions,
    outOfStockInfo,
  };
}

export default useVariantsAvailabilityStatus;
